import { avatarRecipe } from '@repo/themes/styled-system/recipes';
import { styled, type HTMLStyledProps } from '@repo/themes/styled-system/jsx';

export const Avatar = styled('img', avatarRecipe);
export type AvatarProps = HTMLStyledProps<typeof Avatar>;
